import { translation } from "@kvix/shared";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
export const startI18n = () => {
    i18n.use(initReactI18next).init(translation);
};
//# sourceMappingURL=startI18n.js.map